export const inspection = {
  reportName: "Template Name",
  items: "Items",
  models: "Vehicle Model",
  modelsNumber: "Vehicle Model Number",
};
